import React, { useMemo } from "react";
import MostVisitedPagerAndroid from "./MostVisitedPagerAndroid";
import MostVisitedPagerIOS from "./MostVisitedPagerIOS";

const isIOSDevice = () => {
  if (typeof navigator === "undefined") return false;

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  return (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1)
  );
};

/*
|-----------------------------------------------------------------------------
| Platform-specific Most Visited Pager
|-----------------------------------------------------------------------------
|
| iOS keeps the native horizontal scroll-snap implementation that Safari
| handles correctly. Android uses the transform-based horizontal pager that
| already resolved the same nested horizontal/vertical gesture conflict in
| Focus Mode and Saved Mode.
|
*/
const MostVisitedPager = (props) => {
  const useIOSMethod = useMemo(() => isIOSDevice(), []);

  return useIOSMethod ? (
    <MostVisitedPagerIOS {...props} />
  ) : (
    <MostVisitedPagerAndroid {...props} />
  );
};

export default MostVisitedPager;
